import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toFlag } from './values';

export function block(query: QueryObject): Pick<SearchCriteriaParams, 'block'> | null {
  return toFlag(query.block) ? { block: true } : null;
}
